<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import learningApiUser from '@src/services/api/learning/user'
import DefineValidation from '@services/validation/DefineValidation'
import { useLearningAuthStore } from '@stores/auth'
import Modal from '@components/modal/Modal.vue'

const { updateTempAccessToken } = useLearningAuthStore()

const router = useRouter()
const errorMessage = ref('')

const modifiable = ref(true)

const { errors, meta, handleSubmit, handleReset, models } = new DefineValidation((modules) => {
  return {
    email: modules.string().required().email().label('メールアドレス')
  }
})

const formItems = [
  {
    id: 'email',
    type: 'text',
    label: '新メールアドレス',
    length: 256,
    placeholder: ''
  }
]

const currentMailAddress = ref('')

const sendButtonDisabled = computed(() => {
  return !(meta.value.valid && meta.value.dirty)
})

const showCompleteModal = ref(false)

const toMailAuth = () => {
  showCompleteModal.value = false
  router.push({
    name: 'MailAuth'
  })
}

const sendForm = handleSubmit(async (values) => {
  const body = {
    email: models.email.value
  }
  console.log('body', body)
  learningApiUser.editMailAddress(body).then((res) => {
    console.log('editMailAddress res', res)
    updateTempAccessToken(res.data.access_token)
    showCompleteModal.value = true
  }).catch((err) => {
    console.error('editMailAddress err', err.response)
    if (err.response.status === 422) {
      errorMessage.value = 'メール形式で入力してください。'
    } else {
      errorMessage.value = 'エラーが発生しました。'
    }
  })
})

onMounted (() => {
  // ユーザ情報取得
  learningApiUser.getUser().then((res) => {
    console.log('getUser res', res.data)
    currentMailAddress.value = res.data.email
    
    // flagsにnotModifiableがあれば編集不可
    if (res.data.flags && res.data.flags.includes('notModifiable')) {
      modifiable.value = false
    }
  }).catch((err) => {
    console.error('login err', err)
  })
})
</script>

<template>
  <section>
    <div class="container">
      <h2>メールアドレスの変更</h2>
      <p class="topMessage">
        新しいメールアドレスを入力し、確認メールを送信ボタンを押してください。
        <span
          v-if="!modifiable"
          class="attention"
        >
          メールアドレスの変更ができないアカウントです。
        </span>
      </p>
      <form @submit.prevent="sendForm">
        <div class="p-form-field">
          <div class="p-form-field">
            <label class="c-input-label">
              現在のメールアドレス
            </label>
            {{ currentMailAddress }}
          </div>
        </div>
        <div class="p-form-field">
          <div
            v-for="item in formItems"
            :key="item.id"
            class="p-form-field"
          >
            <label
              :for="item.id"
              class="c-input-label"
            ><span class="c-form-required">必須</span>
              {{ item.label }}</label>
            <input
              :id="item.id"
              v-model="models[item.id].value"
              :disabled="!modifiable"
              :type="item.type"
              :class="`c-input-${item.type}`"
              :maxlength="item.length"
              :placeholder="item.placeholder"
              autocomplete="off"
            >
            <span
              v-if="errors.email"
              class="c-validationError"
            >{{ errors.email }}</span>
          </div>
        </div>

        <!-- APIエラー表示 -->
        <div
          v-if="errorMessage"
          class="p-form-error">
          {{ errorMessage }}
        </div>

        <div class="btnContainer">
          <button
            type="submit"
            :disabled="!modifiable"
            class="c-button c-button--medium c-button--yellow"
          >
            確認メールを送信
          </button>
          <RouterLink
            :to="{name:'Dashboard'}"
            class="c-button c-button--medium c-button--border"
          >
            戻る
          </RouterLink>
        </div>
      </form>
    </div>

    <Modal :show="showCompleteModal">
      <template #body>
        <div class="l-modal__body">
          <h2 class="l-modal__ttl">
            メールを送信しました。<br>メールにある認証コードを<br>次の画面で入力してください。
          </h2>
          <div class="l-modal__buttons">
            <button
              class="c-modalBtn c-modalBtn--single c-modalBtn--gray"
              type="button"
              @click="toMailAuth"
            >
              認証コード入力画面へ
            </button>
          </div>
        </div>
      </template>
    </Modal>
  </section>
</template>

<style scoped lang="scss">
.container {
  h2 {
    padding: 30px 0 15px;
    font-size: 26px;
    text-align: left;
    font-weight: bold;
  }
}
.topMessage {
  margin-bottom: 20px;
  .attention {
    display: block;
    color: #F00;
  }
}
.btnContainer {
  margin-top: 20px;
}
</style>
